import React, { Component } from 'react';
import PropTypes from 'prop-types';
import connect from '../store/connect';
import { setEmptyObjectState } from '../actions/actionCreators';
import * as K from '../constants/constants';

import ObjectSearchItem from './ObjectSearchItem';
import ObjectSearchItemEmpty from './ObjectSearchItemEmpty';
import './ObjectSearchListing.css';

class ObjectSearchListing extends Component {
  getEmptyObjectTitleByCategory(category: '') {
    let words = K.category_words[category];
    let str = words.plural;
    return K.emptyObjectTitle(str);
  }
  getEmptyObjectTextByCategory(category: '') {
    let words = K.category_words[category];
    let str = words.singluar;
    return K.emptyObjectText(str);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.currentCategory !== this.props.currentCategory) {
      let newCategory = nextProps.currentCategory;
      this.props.setEmptyObjectState(
        'emptyObjectTitle',
        this.getEmptyObjectTitleByCategory(newCategory)
      );
      this.props.setEmptyObjectState(
        'emptyObjectText',
        this.getEmptyObjectTextByCategory(newCategory)
      );
    }
  }

  render() {
    return (
      <ul className="objectsearchlisting">
        {this.props.objectData.map((item, index) => {
          return (
            <ObjectSearchItem
              key={item.get('id')}
              id={item.get('id')}
              title={item.get('name')}
              type={item.get('objectType')}
              image={item.get('image')}
              link={item.get('url')}
              selectObject={this.props.selectObject}
              selectedObject={this.props.selectedObject}
              scrollObjectIntoView={this.props.scrollObjectIntoView}
              classModifier={
                this.props.theme ? `--theme-${this.props.theme}` : ''
              }
            />
          );
        })}

        {!this.props.objectData.size ? (
          <ObjectSearchItemEmpty
            title={this.props.emptyObjectTitle}
            text={this.props.emptyObjectText}
            classModifier={
              this.props.theme ? `--theme-${this.props.theme}` : ''
            }
          />
        ) : null}
      </ul>
    );
  }
}
ObjectSearchListing.propTypes = {
  setEmptyObjectState: PropTypes.func,
  emptyObjectTitle: PropTypes.string,
  emptyObjectText: PropTypes.string,
};
ObjectSearchListing.defaultProps = {
  setEmptyObjectState: () => {},
  emptyObjectTitle: '',
  emptyObjectText: '',
};
export default connect(
  ObjectSearchListing,
  {
    setEmptyObjectState,
  },
  (store, props) => ({
    emptyObjectTitle: store.emptyobjectstate.get('emptyObjectTitle'),
    emptyObjectText: store.emptyobjectstate.get('emptyObjectText'),
  })
);



// WEBPACK FOOTER //
// ./src/js/components/ObjectSearchListing.js